import IState from '@/interfaces/IState';
import {ActionContext} from 'vuex';

export default async (context: ActionContext<IState, IState>, blacklistDeviceId: string) => {
    if (!blacklistDeviceId) {
        return Promise.reject('Incorrect blacklist device id');
    }
    try {
        const blacklistDevice = await context.dispatch('backendTalker', {
            request: 'blacklist_device_remove',
            id: blacklistDeviceId
        });
        if (blacklistDevice.status === 204) {
            await context.dispatch('blackListDevicesList', {query: '?pagination=true&page=1'});
            return 'deleted';
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
